import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Navbar from '../NavBar/Navbar';
import FadeLoader from "react-spinners/FadeLoader";
import PricingPlanList from './PricingPlanList.jsx';
import Holidays from './Holidays.jsx';
import AddNewPricing from './AddNewPricing.jsx';
import AddNewHoliday from './AddNewHoliday.jsx';
import './Pricing.css';

const Pricing = (props) => {
    const [loader, setLoader] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [pricingPageMode, setPricingPageMode] = useState("list"); // "list" | "create"
    const [editingPricingPlan, setEditingPricingPlan] = useState(null);
    const [updatePricingData, setUpdatePricingData] = useState(false);
    const [isHolidayPopupOpen, setIsHolidayPopupOpen] = useState(false);
    const [editPopup, setEditPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userData, setUserdata] = useState();
    const [refreshHolidays, setRefreshHolidays] = useState(0);


    // ================= HANDLERS =================

    const handleNewPricingPlan = () => {
        setPricingPageMode("create");
        setEditingPricingPlan(null);
    };

    const handleAddNewHoliday = () => {
        setIsHolidayPopupOpen(true);
    };

    const handleCancelHoliday = () => {
        setIsHolidayPopupOpen(false);
        setEditPopup(false);
    };

    const handleHolidaySaved = () => {
        setIsHolidayPopupOpen(false);
        setEditPopup(false);
        setRefreshHolidays(prev => prev + 1); // Toggle to trigger refresh
    };
    const handleBackToPricingList = () => {
        setPricingPageMode("list");
        setEditingPricingPlan(null);
        setUpdatePricingData(prev => !prev); // ✅ Trigger refresh
    };

    const handleEditPlan = (row) => {
        setEditingPricingPlan(row);
        setPricingPageMode("create");
    };

    // ================= RENDER =================
    const tabStyle = {
        textTransform: "none",
        fontWeight: 500,
        fontFamily: "Inter, sans-serif",
        fontSize: "16px",
        lineHeight: 1,
        letterSpacing: 0,
        color: "#121212",
        padding: "0 0 8px 0",           
        minWidth: "auto",     
        minHeight: "unset",
        "&.Mui-selected": {
        fontWeight: 600, 
        }  
    }
    return (
        <>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            <Navbar userData={props.userData} />

            <div className='container-fluid p-0'>
                <div className="lotmanagement1">

                    {/* ================= CREATE/EDIT PRICING PAGE ================= */}
                    {pricingPageMode === "create" && (
                        <AddNewPricing
                            mode={editingPricingPlan ? "edit" : "create"}
                            pricingPlanData={editingPricingPlan}
                            setEditingPricingPlan={setEditingPricingPlan}
                            onBackToPricing={handleBackToPricingList}
                            setIsPricingPopupOpen={() => setPricingPageMode("list")}
                            setUpdateData={setUpdatePricingData}
                            setLoader={setLoader}
                            setLoading={setLoading}
                            loading={loading}
                            onSaveSuccess={() => {
                                setPricingPageMode("list");
                                setEditingPricingPlan(null);
                                setUpdatePricingData(prev => !prev);
                            }}
                        />
                    )}

                    {/* ================= TABS & LIST VIEW ================= */}
                    {pricingPageMode === "list" && (
                        <>
                            {/* HEADER */}
                            <div className="row alignLeft">
                                <div className="col-7">
                                    <div className='pricing-plan-header'>
                                        Pricing & Holiday Configuration
                                    </div>
                                </div>
                            </div>

                            {/* TABS + CREATE BUTTON */}
                            <div className="row mb-2">
                                <div className="col-12">
                                    <div className="d-flex align-items-center">
                                        <Tabs
                                            value={activeTab}
                                            onChange={(_, v) => setActiveTab(v)}
                                            textColor="inherit"
                                            indicatorColor="primary"
                                             sx={{
                                                minHeight: "unset",   
                                                padding: 0,
                                                "& .MuiTabs-flexContainer": {
                                                gap: "24px"
                                                }
                                            }}
                                            >
                                            <Tab label="Pricing Plan" sx={tabStyle} />
                                            <Tab label="Holiday Configuration" sx={tabStyle} />
                                        </Tabs>


                                        <Button
                                            variant="contained"
                                            className="add-new-pricing"
                                            sx={{
                                                textTransform: "none",
                                                padding: "10px",
                                                borderRadius: "5px",
                                                fontWeight: "bold",
                                                backgroundColor: "#0A66C2",
                                                boxShadow: "none",
                                                "&:hover": {
                                                    backgroundColor: "#084e99"
                                                }
                                            }}
                                            onClick={activeTab === 0 ? handleNewPricingPlan : handleAddNewHoliday}
                                        >
                                            {activeTab === 0
                                                ? "+ Create New Pricing Plan"
                                                : "+ Add New Holiday"}
                                        </Button>


                                    </div>
                                </div>
                            </div>

                            {/* TAB CONTENT */}
                            {activeTab === 0 && (
                                <PricingPlanList
                                    onEditPlan={handleEditPlan}
                                    updateTrigger={updatePricingData}
                                    setLoader={setLoader}

                                />
                            )}

                            {activeTab === 1 && (
                                <Holidays
                                    refreshTrigger={refreshHolidays}
                                />
                            )}
                        </>
                    )}

                    {/* ================= HOLIDAY POPUP ================= */}
                    {isHolidayPopupOpen && (
                        <div className="popup-overlay">
                            <div className="popup-content">
                                <AddNewHoliday
                                    handleCancelHoliday={handleCancelHoliday}
                                    setEditPopup={setEditPopup}
                                    editPopup={editPopup}
                                    holidayData={userData}
                                    setIsHolidayPopupOpen={setIsHolidayPopupOpen}
                                    setLoading={setLoading}
                                    setLoader={setLoader}
                                    loading={loading}
                                    loader={loader}
                                    onHolidaySaved={handleHolidaySaved}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Pricing;